import { memo, useCallback, useMemo, useReducer } from 'react';
import GoogleAddressContext from './GoogleAddressContext';
import initialGoogleAddressState from './initialGoogleAddressState';
import googleAddressReducer from './reducer/googleAddress.reducer';
import * as action from './reducer/googleAddress.actions';
import {
  IautoSetGoogleAddressProps,
  IresetGoogleAddressProps,
  IsetGoogleAddressProps,
} from 'interfaces/googleAddress.interface';
import { ChildrenProps } from 'interfaces/general.interface';

const GoogleAddressProvider = ({ children }: ChildrenProps) => {
  const [googleAddressState, dispatch] = useReducer(
    googleAddressReducer,
    initialGoogleAddressState
  );

  const setGoogleAddress = useCallback(
    ({ formKey, field, value }: IsetGoogleAddressProps) => {
      if (!googleAddressState.googleAddresses || !field) return;
      action.setGoogleAddressAction({
        dispatch,
        formKey,
        field,
        value,
      });
    },
    [googleAddressState.googleAddresses]
  );

  const autoSetGoogleAddress = useCallback(({ values }: IautoSetGoogleAddressProps) => {
    action.autoSetGoogleAddressAction({
      dispatch,
      values,
    });
  }, []);

  const resetGoogleAddress = useCallback(
    ({ formKey, values }: IresetGoogleAddressProps) => {
      action.resetGoogleAddressAction({
        dispatch,
        formKey,
        values,
      });
    },
    []
  );

  const memoProvider = useMemo(
    () => ({
      ...googleAddressState,
      setGoogleAddress,
      autoSetGoogleAddress,
      resetGoogleAddress,
    }),
    [googleAddressState, setGoogleAddress, autoSetGoogleAddress, resetGoogleAddress]
  );

  return (
    <GoogleAddressContext.Provider value={memoProvider}>
      {children}
    </GoogleAddressContext.Provider>
  );
};

export default memo(GoogleAddressProvider);
